const mutations = {
  setLoginData(state, data) {
    state.loginData = data;
  },
  setAccessToken: (state, accessToken) => {
    state.accessToken = accessToken;
    if (!!accessToken) state.keepAlive = new Date().getTime();
  }
};

export default mutations;
